export default __webpack_public_path__ + "static/media/linkedin.8762f6e9.svg";